<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>卡密记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        </el-card>
      </div>
      
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable >
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" @click="query" :loading="state">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state">重 置</el-button>
      </el-form>
      
      <el-table :data="integralData" border style="width: 100%" stripe>
        <el-table-column prop="softName" label="代理软件" width="220"></el-table-column>
        <el-table-column prop="action" label="动作" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '删卡'" style="color: #d80821">删卡</span>
            <span v-if="scope.row.action === '提卡'" style="color: #237804">提卡</span>
            <span v-if="scope.row.action === '续费'" style="color: #ad6800">续费</span>
            <span v-if="scope.row.action === '多开转换'" style="color: #B28B67">多开转换</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="80"></el-table-column>
        <el-table-column prop="cardType" label="卡类" width="200"></el-table-column>
        <el-table-column prop="integral" label="积分变动" width="100"></el-table-column>
        <el-table-column prop="record" label="卡密记录">
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.record)">
                  <span class="code-span" v-for="item in scope.row.record" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.record) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.record" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.record)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.record}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.record">{{ scope.row.record | capitalize }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="时间" width="165"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data(){
    return{
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      integralData:[],
      state:false,
      searchForm:{},
      allSoftName:[],
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getIntegralLog()
  },
  methods:{
    async getIntegralLog(){
      //console.log(this.queryInfo);
      const result = await this.$http.get("getagentlog",{
        params:this.queryInfo
      });
      console.log(result);
      //this.integralData = result.data.data.data
      console.log('result.data.data',result.data.data.data);
      
      if(result.data.data.data){
        this.integralData = result.data.data.data.map(element => {
          if(element.record.indexOf('{') > -1){
            element.record = JSON.parse(element.record)
          }else if(element.record.indexOf('[') > -1){
            element.record = JSON.parse(element.record)
          }
          return element
        })
      }else{
        this.integralData = []
      }
      this.total = result.data.data.total
    },

    async getCardTypeSoftName(){
      this.stateOver = true
      const result = await this.$http.get("getcardsoftlist",{
        params:this.queryInfo
      });
      this.stateOver = false
      //console.log('getresult',result);
      this.allSoftNameObj = result.data.data.result
      this.allSoftName = result.data.data.result.map(element => {
        //console.log('result',element.softName);
        return element.softName
      })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getIntegralLog()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getIntegralLog()
    },
    refresh(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getIntegralLog()
    },
    reSet(){
      this.queryInfo.pagenum = 1
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.getIntegralLog()
    }
  },
  filters:{
    capitalize(value){
      if(Array.isArray(value)){
        value = value.toString()
        value = value.replace('[','')
        value = value.replace(']','')
      }
      return value
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
  .el-table{
    .text-record{
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
}
</style>